module.exports = __webpack_public_path__ + "static/media/check.f673c27d.svg";